import { ExternalLink, Mail, MapPin, Phone, ShieldCheck, User } from "lucide-react";
import { fmtDate } from "@/lib/api";

const Row = ({ icon: Icon, label, value, testId }) => (
  <div className="flex items-start gap-4 py-4">
    <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-neutral-100">
      <Icon size={15} className="text-neutral-500" />
    </div>
    <div className="min-w-0 flex-1">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-400">{label}</p>
      <div className="mt-0.5 text-sm text-neutral-800" data-testid={testId}>
        {value || <span className="text-neutral-400">Not added yet</span>}
      </div>
    </div>
  </div>
);

export const ProfileCard = ({ customer, accountUrl }) => {
  const fullName = [customer.first_name, customer.last_name].filter(Boolean).join(" ");
  return (
    <div className="rounded-2xl border border-neutral-200 bg-white p-6" data-testid="account-profile">
      <div className="flex items-center justify-between gap-3">
        <h2 className="font-heading text-lg font-bold">Profile</h2>
        {customer.member_since && (
          <p className="text-xs text-neutral-400">Member since {fmtDate(customer.member_since)}</p>
        )}
      </div>
      <div className="mt-2 divide-y divide-neutral-100">
        <Row icon={User} label="Name" value={fullName} testId="profile-name" />
        <Row icon={Mail} label="Email" value={customer.email} testId="profile-email" />
        <Row icon={Phone} label="Phone" value={customer.phone} testId="profile-phone" />
        <Row
          icon={MapPin}
          label="Default address"
          testId="profile-address"
          value={
            customer.default_address?.length ? (
              <address className="not-italic leading-relaxed">
                {customer.default_address.map((l, i) => (
                  <span key={i} className="block">
                    {l}
                  </span>
                ))}
              </address>
            ) : null
          }
        />
      </div>
      <div className="mt-4 flex flex-wrap items-center justify-between gap-3 rounded-xl bg-neutral-50 p-4">
        <p className="flex items-center gap-1.5 text-xs text-neutral-500">
          <ShieldCheck size={13} /> Your details are stored securely by Shopify.
        </p>
        {accountUrl && (
          <a
            href={`${accountUrl}/profile`}
            target="_blank"
            rel="noreferrer"
            data-testid="profile-manage-link"
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-neutral-800 underline underline-offset-4"
          >
            Edit name, phone & addresses <ExternalLink size={12} />
          </a>
        )}
      </div>
    </div>
  );
};
